module.exports = __webpack_public_path__ + "img/3.ae603c19.png";